
import i18n from '@/plugins/i18n'
export default {
  browse:{
    table:{
      headers: [
        {
          text:  i18n.t("model.prop.no"),
          value: 'index',
          sortable: false,
          filterable: false,
        },
        {
          text:  'School Year',
          value: 'schoolYear',
        },
        {
          text:  'Chapter Key',
          value: 'chapterKey',
        },
         {
          text:  'Question Key',
          value: 'questionKey',
        },
        {
          text:  'Grade',
          value: 'grade',
        },
         {
          text:  'Top Star',
          value: 'topStar',
        },
        {
          text: "Updated",
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  read:false,
  add:false,
  edit:false,
  delete:true,
}